import { apiRequest } from 'src/api';

const documentTypesDataAdapter = data => ({
  docusignURL: data.docusign_link,
});

export const getConsentURL = async (accountId, consentTypeId) => {
  return apiRequest({
    url: `/api/v1/accounts/${accountId}/consent_types/${consentTypeId}/`,
    method: 'GET',
    responseDataAdapter: documentTypesDataAdapter,
  });
};

export const getStatusChangeMessage = async (
  financialInstitutionId,
  accountId,
  newStatus
) => {
  return apiRequest({
    url: `/api/v1/fis/${financialInstitutionId}/accounts/${accountId}/status_change_message/?new_status=${encodeURIComponent(
      newStatus
    )}`,
    method: 'GET',
    responseDataAdapter: response => ({ message: response.message }),
  });
};

export const getSubmission = ({ financialInstitutionId, accountId }) => {
  return apiRequest({
    url: `/api/v1/fis/${financialInstitutionId}/accounts/${accountId}/submission/`,
    method: 'GET',
    responseDataAdapter: response => response,
  });
};
export const sendBaseMerchantApplication = ({ accountId }) => {
  return apiRequest({
    url: `/api/v1/accounts/${accountId}/base_merchant_applications/`,
    method: 'POST',
    body: {},
    responseDataAdapter: response => response,
  });
};
